import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    CreateActivityTracker,
    GetTrackByDeliveryId,
    UploadActivityTracker,
} from '../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { useDispatch, useSelector } from 'react-redux';
import { TABLES } from '../../../../../Apis/Tables';
import { toast } from 'react-toastify';
import {ACTIVITY_TRACKER_ITEM_MODEL} from "../Model/Model";
import { permissionObj } from '../../../../../Helpers/permission';

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeliveryTrackingSectionApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [modified, setModified] = useState(false);
    // Controls visibility of the delivery record modal
    const [showModalDeliveryRecord, setShowModalDeliveryRecord] = useState(false);
    // Retrieves delivery details from Redux store
    const delivery = useSelector((state) => state.equipmentSlice.getDeliveryById);
    // Table option used for equipment material operations
    const option = TABLES.EQUIPMENT_MATERIAL;
    // Stores activity tracking history related to the delivery
    const [activityTracker, setActivityTracker] = useState(null);
    // Retrieves authentication state from Redux store
    const authState = useSelector((state) => state.authenticatioauthennSlice);
    // Logged-in user ID
    const userId = authState?.user?.data?.id;
    const [emptyFields, setEmptyFields] = useState(false);
    const [activityTrackerItem, setActivityTrackerItem] = useState({...ACTIVITY_TRACKER_ITEM_MODEL});
    const deliveryItem = delivery?.data?.data;
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const contractorId = sessionStorage.getItem('contractorId');
    // Contractors manage their own tracking, employees need the permission
    const updatePermission = contractorId || DEV ||
        authState?.permission?.includes(permissionObj?.WEB_CONTRACTOR_UPDATE);

    /**
     * Syncs Redux delivery data with local state
     * when the delivery ID matches the loaded delivery
     */
    useEffect(() => {
        if (!delivery) return;

        setActivityTrackerItem(prev => ({...prev, equipmentDeliveryId: deliveryItem?.id}))

    }, [delivery]);

    /**
     * Fetches activity tracker data whenever the delivery ID changes
     * or when a modification occurs (e.g. new message added)
     */
    useEffect(() => {
        if (deliveryItem?.id) {
            dispatch(GetTrackByDeliveryId(deliveryItem?.id)).then(
                ({
                    payload: {
                        data: { success, data },
                    },
                }) => {
                    if (success === true) {
                        setActivityTracker(data);
                    }
                },
            );
        }
    }, [deliveryItem?.id, modified]);

    /**
     * Handles sending a new message with an optional file
     */
    const handleSendMessage = ({ text, file }) => {
        if (!activityTrackerItem.isValid({message: text})) {
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);
        createActivityTracker(text, file);
    };

    /**
     * Creates a new activity tracker record and uploads a file if provided
     */
    const createActivityTracker = (message, file) => {
        const aux = activityTrackerItem.toRegister({equipmentDeliveryId:deliveryItem.id, userId, message});

        dispatch(CreateActivityTracker(aux))
            .then(({ payload: createRes }) => {
                const successCreate = createRes?.data?.success;
                const trackerData = createRes?.data?.data;

                if (!successCreate || !trackerData?.id) return Promise.reject();
                if (file)  return uploadActivityTracker(trackerData.id, file);
                return Promise.resolve();
            })
            .then(() => {
                toast.success(t('has_been_created_successfully'));
                setModified(true);
            });
    };
    /**
     * Uploads a file associated with an activity tracker record
     */
    const uploadActivityTracker = (trackerId, file) => {
        const formData = new FormData();
        formData.append('id', trackerId);
        formData.append('fileUploadDto.userFileNames', file.name);
        formData.append('fileUploadDto.files', file);
        return dispatch(UploadActivityTracker(formData));
    };

    return {
        dispatch,
        option,
        t,
        setShowModalDeliveryRecord,
        showModalDeliveryRecord,
        activityTracker,
        handleSendMessage,
        emptyFields,
        modified,
        setModified,
        deliveryItem,
        updatePermission
    };
};

export default DeliveryTrackingSectionApp;
